import {ValueObject} from '@s-ui/domain'

export class GetLoanCalculationsTransactionsRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {Number} data.entry
   * @param {String} data.lender
   * @param {String} data.plateRegistrationDate
   * @param {Number} data.price
   * @param {Number} data.terms
   **/
}
